import { Lock } from "lucide-react";

import type { Status } from "../api/types";
import { Badge } from "../ui/Badge";
import { PRIORITY_LABELS, PRIORITY_TONES, STATUS_LABELS, STATUS_TONES } from "./labels";

export function StatusBadge({ status }: { status: Status }) {
  return <Badge tone={STATUS_TONES[status]}>{STATUS_LABELS[status]}</Badge>;
}

export function PriorityBadge({ priority }: { priority: number }) {
  return <Badge tone={PRIORITY_TONES[priority] ?? "neutral"}>{PRIORITY_LABELS[priority] ?? `P${priority}`}</Badge>;
}

export function RestrictedBadge() {
  return (
    <Badge tone="danger">
      <Lock size={11} aria-hidden="true" />
      Confidential
    </Badge>
  );
}
